import {connect} from 'react-redux'
import moment from 'moment'

import {Planner} from './planner.component'
import {
    prependDay,
    appendDay,
    updateArrivalDate,
    updateDepartureDate,
    updateTotalDays,

} from './planner.action'
import {resizeLegs, deleteLeg} from '../leg/leg.action'


const mapStateToProps = (state) => {
    let arrival = state.getIn(['document', 'properties', 'arrivalDate'])
    let departure = state.getIn(['document', 'properties', 'departureDate'])
    let legs = state.getIn(['document', 'legs'])

    return {
        totalDays: state.getIn(['document', 'properties', 'totalDays']) || 1,
        arrivalDate: arrival ? moment(arrival) : null,
        departureDate: departure ? moment(departure) : null,
        sidebarActive: state.getIn(['uiState', 'sidebarActive']),
        legs: legs
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onPrependDay: () => {
            dispatch(prependDay())
        },
        onAppendDay: () => {
            dispatch(appendDay())
        },
        onUpdateArrivalDate: (date, departureDate, totalDays, legs) => {
            let maxTripLenght = totalDays
            if (departureDate && date && departureDate.isValid() && date.isValid()) {
                maxTripLenght = departureDate.diff(date, 'days')
            }
            legs.forEach((leg) => {
                const start = leg.getIn(['properties', 'start'])
                const end = leg.getIn(['properties', 'end'])
                if (start >= maxTripLenght) {
                    dispatch(deleteLeg(leg))
                } else if (end > maxTripLenght) {
                    dispatch(resizeLegs([{start: start, end: maxTripLenght, leg: leg}]))
                }
            })
            dispatch(updateArrivalDate(date))
        },
        onUpdateDepartureDate: (date, arrivalDate, totalDays, legs) => {
            let maxTripLenght = totalDays
            if (arrivalDate && date && arrivalDate.isValid() && date.isValid()) {
                maxTripLenght = date.diff(arrivalDate, 'days')
            }
            legs.forEach((leg) => {
                const start = leg.getIn(['properties', 'start'])
                const end = leg.getIn(['properties', 'end'])
                if (start >= maxTripLenght) {
                    dispatch(deleteLeg(leg))
                } else if (end > maxTripLenght) {
                    dispatch(resizeLegs([{start: start, end: maxTripLenght, leg: leg}]))
                }
            })
            dispatch(updateDepartureDate(date))
        },
        onUpdateTotalDays: () => {
            dispatch(updateTotalDays())
        },
    }
}

const PlannerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Planner)

export default PlannerContainer
